"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var workflow_designer_point_matrix_model_1 = require("./workflow-designer-point-matrix.model");
var workflow_designer_point_model_1 = require("./workflow-designer-point.model");
var WorkflowDesignerCreateStatePointsModel = /** @class */ (function () {
    function WorkflowDesignerCreateStatePointsModel(state) {
        var _this = this;
        this.state = state;
        this.matrix = workflow_designer_point_matrix_model_1.WorkflowDesignerPointsMatrix;
        this.points = [];
        this.transitionFrom = null;
        this.transitionFromOrigin = null;
        this.matrix.forEach(function (matrix, index) {
            var point = new workflow_designer_point_model_1.WorkflowDesignerPointModel();
            point.attr.cx = matrix.cx;
            point.attr.cy = matrix.cy;
            point.attr.origin = index;
            point.onDragStart = function (create) {
                create.position(state.centerX, state.centerY);
                create.centerX = _this.getCenterX(index);
                create.centerY = _this.getCenterY(index);
                _this.state.hasNearest = false;
            };
            point.onDragEnd = function (create, viewport) {
                create.attr.transitionFrom = _this.state;
                create.attr.transitionFromOrigin = index;
                viewport.gizmo.start.position(create.centerX, create.centerY);
                if (create.attr.nearest) {
                    viewport.gizmo.end.position(create.attr.nearest.x, create.attr.nearest.y);
                }
                else {
                    viewport.gizmo.end.position(viewport.cursorX, viewport.cursorY);
                }
                viewport.gizmo.stateRect = !create.attr.nearest;
                _this.state.hasNearest = false;
            };
            point.onMove = function (create, viewport) {
                create.attr.nearest = viewport.calculateNearestStatePoint(viewport.cursorX, viewport.cursorY);
                _this.state.hasNearest = create.attr.nearest;
            };
            _this.points.push(point);
        });
    }
    WorkflowDesignerCreateStatePointsModel.prototype.getCenterX = function (index) {
        return this.state.x + this.state.width * this.matrix[index].x;
    };
    WorkflowDesignerCreateStatePointsModel.prototype.getCenterY = function (index) {
        return this.state.y + this.state.height * this.matrix[index].y;
    };
    return WorkflowDesignerCreateStatePointsModel;
}());
exports.WorkflowDesignerCreateStatePointsModel = WorkflowDesignerCreateStatePointsModel;
//# sourceMappingURL=workflow-designer-create-state-points.model.js.map